<template>
  <div class="home">
    <Header></Header>
    <div class="carousel-box">
      <el-carousel :interval="3500" arrow="never" class="d-md-block d-none">
        <el-carousel-item v-for="item in bgBanner" :key="item.id">
          <div
            class="banner d-md-block d-none"
            :style="{ background: 'url(' + item.url + ')' }"
          ></div>
        </el-carousel-item>
      </el-carousel>
      <h1 class="banner_title d-md-block d-none">
        {{ $t("header.hometitle") }}
      </h1>
    </div>

    <div class="carousel-box">
      <el-carousel :interval="3500" arrow="never" class="d-md-none d-block">
        <el-carousel-item v-for="item in bgBanner2" :key="item.id">
<!--          :style="{ background: 'url(' + item.url + ')' }"-->
          <el-image
            class="banner-mobile d-md-none d-block"
            :src=item.url
          ></el-image>
        </el-carousel-item>
      </el-carousel>
      <h1 class="banner_title d-md-none d-block">
        {{ $t("header.hometitle") }}
      </h1>
    </div>
    <!-- 手机版banner -->

    <div class="container">
      <!-- 公司简介 -->
      <div class="home-item brief">
        <div class="row">
          <div class="col-md-5 no-padding d-md-block d-none">
            <img
              src="../assets/image/home-huize.png"
              class="img-fluid"
              alt=""
            />
          </div>
          <div class="col-md-7 brief-bg d-md-block d-none no-padding">
            <div class="title">{{ $t("home.brief") }}</div>
            <div class="d-md-block d-none">
              <div class="brief_txt">
                <p class="brief_txt_p1">
                  {{ $t("home.brief_txt1") }}
                </p>
                <p>
                  {{ $t("home.brief_txt2") }}
                </p>
                <p>
                  {{ $t("home.brief_txt3") }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 手机模式 -->
        <div class="brief-mobile d-xs-block d-md-none">
          <div class="title">{{ $t("home.brief") }}</div>
          <div class="img-box" style="margin-bottom: 23px">
            <img
              src="../assets/image/huize.png"
              class="huize-img img-fluid"
              alt=""
            />
          </div>
          <div class="txt-box">
            <p>
              {{ $t("home.brief_txt1") }}
            </p>
            <p>
              {{ $t("home.brief_txt2") }}
            </p>
            <p>
              {{ $t("home.brief_txt3") }}
            </p>
          </div>
        </div>

        <!-- 四个模块 -->
        <ul class="company_brief">
          <li class="brief_item">
            <div class="brief_img">
              <img src="../assets/image/home-1.png" alt="img" />
            </div>
            <h5>{{ $t("home.innovate") }}</h5>
            <p>{{ $t("home.innovate_txt") }}</p>
          </li>
          <li class="brief_item">
            <div class="brief_img">
              <img src="../assets/image/home-2.png" alt="img" />
            </div>
            <h5>{{ $t("home.security") }}</h5>
            <p>{{ $t("home.security_txt") }}</p>
          </li>
          <li class="brief_item">
            <div class="brief_img">
              <img src="../assets/image/home-3.png" alt="img" />
            </div>
            <h5>{{ $t("home.quality") }}</h5>
            <p>{{ $t("home.quality_txt") }}</p>
          </li>
          <li class="brief_item">
            <div class="brief_img">
              <img src="../assets/image/home-4.png" alt="img" />
            </div>
            <h5>{{ $t("home.target") }}</h5>
            <p>{{ $t("home.target_txt") }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 工程案例 -->
    <div class="home-item cases">
      <div class="container">
        <div class="row title-box">
          <div class="col-md-5 col-8">
            <div class="title text-left">
              {{ $t("home.equipment_cases") }}
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="more">
<!--              <a href="javascript:;" class="moreBtn">-->
<!--                more-->
<!--                <img-->
<!--                  src="../assets/image/home-right.png"-->
<!--                  class="img-fluid"-->
<!--                  alt="more"-->
<!--                />-->
<!--              </a>-->
            </div>
          </div>
        </div>

        <div class="cases_box"
          >
          <!-- 案例标题 -->

            <div class="app-swiper" style="display: none">
  <div
          class="swiper-container swiper1 d-none d-md-block app"
          id="swiper_container"
          ref="mySwiper"
          @mouseenter="on_enter"
          @mouseover="on_over"
          @mouseleave="on_leave"
  >
    <!-- 轮播图 -->
    <div class="swiper-wrapper"
    >
      <div class="swiper-slide"
      >
        <div class="cases-item">
          <div class="row">
            <div class="col-md-8">
              <div class="cases-item-img">
                <img
                        src="../assets/image/home-7.png"
                        class="img-fluid"
                        alt="img"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="cases-item-txt">
                <div class="cases-item-img">
                  <img
                          src="../assets/image/home-7-luban.png"
                          class="img-fluid"
                          alt="img"
                  />
                </div>
                <h5>{{ $t("home.chongqing") }}</h5>
                <i></i>

                <p>
                  {{ $t("home.chongqing_txt3") }}
                </p>
                <router-link
                        :to="{ path: '/cases/detail', query: { id: 1 } }"
                        tag="a"
                        class="moreBtn"
                >
                  more
                  <img
                          src="../assets/image/home-right.png"
                          class="img-fluid"
                          alt="more"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide"
      >
        <div class="cases-item">
          <div class="row">
            <div class="col-md-8">
              <div class="cases-item-img">
                <img
                        src="../assets/image/home-9.png"
                        class="img-fluid"
                        alt="img"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="cases-item-txt">
                <div class="cases-item-img">
                  <img
                          src="../assets/image/home-9-shuidian.png"
                          class="img-fluid"
                          alt="img"
                  />
                </div>
                <h5>{{ $t("home.sichuan") }}</h5>
                <i></i>

                <p>{{ $t("home.sichuan_txt") }}</p>
                <router-link
                        :to="{ path: '/cases/detail', query: { id: 2 } }"
                        tag="a"
                        class="moreBtn"
                >
                  more
                  <img
                          src="../assets/image/home-right.png"
                          class="img-fluid"
                          alt="more"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide"
      >
        <div class="cases-item">
          <div class="row">
            <div class="col-md-8">
              <div class="cases-item-img">
                <img
                        src="../assets/image/home-10.png"
                        class="img-fluid"
                        alt="img"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="cases-item-txt">
                <div class="cases-item-img">
                  <img
                          src="../assets/image/home-10-2.png"
                          class="img-fluid"
                          alt="img"
                  />
                </div>
                <h5>{{ $t("home.xinjian") }}</h5>
                <i></i>

                <p>
                  {{ $t("home.xinjian_txt") }}
                </p>
                <router-link
                        :to="{ path: '/cases/detail', query: { id: 3 } }"
                        tag="a"
                        class="moreBtn"
                >
                  more
                  <img
                          src="../assets/image/home-right.png"
                          class="img-fluid"
                          alt="more"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide"
      >
        <div class="cases-item">
          <div class="row">
            <div class="col-md-8">
              <div class="cases-item-img">
                <img
                        src="../assets/image/home-11.png"
                        class="img-fluid"
                        alt="img"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="cases-item-txt">
                <div class="cases-item-img">
                  <img
                          src="../assets/image/home-11-2.png"
                          class="img-fluid"
                          alt="img"
                  />
                </div>
                <h5>{{ $t("home.xizang") }}</h5>
                <i></i>

                <p>
                  {{ $t("home.xizang_txt") }}
                </p>
                <router-link
                        :to="{ path: '/cases/detail', query: { id: 4 } }"
                        tag="a"
                        class="moreBtn"
                >
                  more
                  <img
                          src="../assets/image/home-right.png"
                          class="img-fluid"
                          alt="more"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-slide"
      >
        <div class="cases-item">
          <div class="row">
            <div class="col-md-8">
              <div class="cases-item-img">
                <img
                        src="../assets/image/home-12.png"
                        class="img-fluid"
                        alt="img"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="cases-item-txt">
                <div class="cases-item-img">
                  <img
                          src="../assets/image/home-12-2.png"
                          class="img-fluid"
                          alt="img"
                  />
                </div>
                <h5>{{ $t("home.lake") }}</h5>
                <i></i>

                <p>
                  {{ $t("home.lake_txt") }}
                </p>
                <router-link
                        :to="{ path: '/cases/detail', query: { id: 5 } }"
                        tag="a"
                        class="moreBtn"
                >
                  more
                  <img
                          src="../assets/image/home-right.png"
                          class="img-fluid"
                          alt="more"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination swp1"></div>
  </div>
</div>
          <!-- 案例详情 -->

          <el-carousel :interval="2000"  height="700px" @change="changeCarouse" trigger="click" class="pcSwiper">
            <ul class="cases-title"  >
              <li
                      v-for="(item, index) in cases"
                      :key="index"
                      :class="{ clickActive: item.isActive }"


              >
                <!--              @click="changeCases(item)"-->
                <!--              @click="tabTile(item)"-->
                <a href="javascript:;">{{ item.title }}</a>
              </li>
            </ul>
                    <el-carousel-item style="height:500px;margin-top: 70px">
                      <!--              <h3 class="medium">{{ item }}</h3>-->
                      <div class="swiper-slide"
                      >
                        <div class="cases-item">
                          <div class="row">
                    <div class="col-md-8">
                      <div class="cases-item-img">
                        <img
                                src="../assets/image/home-7.png"
                                class="img-fluid"
                                alt="img"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="cases-item-txt">
                        <div class="cases-item-img">
                          <img
                                  src="../assets/image/home-7-luban.png"
                                  class="img-fluid"
                                  alt="img"
                          />
                        </div>
                        <h5>{{ $t("home.chongqing") }}</h5>
                        <i></i>

                        <p>
                          {{ $t("home.chongqing_txt3") }}
                        </p>
                        <router-link
                                :to="{ path: '/cases/detail', query: { id: 1 } }"
                                tag="a"
                                class="moreBtn"
                        >
                          more
                          <img
                                  src="../assets/image/home-right.png"
                                  class="img-fluid"
                                  alt="more"
                          />
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
                    <el-carousel-item style="height:500px;margin-top: 70px">
                      <div class="swiper-slide"
                      >
                        <div class="cases-item">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="cases-item-img">
                                <img
                                        src="../assets/image/home-9.png"
                                        class="img-fluid"
                                        alt="img"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="cases-item-txt">
                                <div class="cases-item-img">
                                  <img
                                          src="../assets/image/home-9-shuidian.png"
                                          class="img-fluid"
                                          alt="img"
                                  />
                                </div>
                                <h5>{{ $t("home.sichuan") }}</h5>
                                <i></i>

                                <p>{{ $t("home.sichuan_txt") }}</p>
                                <router-link
                                        :to="{ path: '/cases/detail', query: { id: 2 } }"
                                        tag="a"
                                        class="moreBtn"
                                >
                                  more
                                  <img
                                          src="../assets/image/home-right.png"
                                          class="img-fluid"
                                          alt="more"
                                  />
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                    <el-carousel-item style="height:500px;margin-top: 70px">
                      <div class="swiper-slide"
                      >
                        <div class="cases-item">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="cases-item-img">
                                <img
                                        src="../assets/image/home-10.png"
                                        class="img-fluid"
                                        alt="img"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="cases-item-txt">
                                <div class="cases-item-img">
                                  <img
                                          src="../assets/image/home-10-2.png"
                                          class="img-fluid"
                                          alt="img"
                                  />
                                </div>
                                <h5>{{ $t("home.xinjian") }}</h5>
                                <i></i>

                                <p>
                                  {{ $t("home.xinjian_txt") }}
                                </p>
                                <router-link
                                        :to="{ path: '/cases/detail', query: { id: 3 } }"
                                        tag="a"
                                        class="moreBtn"
                                >
                                  more
                                  <img
                                          src="../assets/image/home-right.png"
                                          class="img-fluid"
                                          alt="more"
                                  />
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </el-carousel-item>
                    <el-carousel-item style="height:500px;margin-top: 70px">
                      <div class="swiper-slide"
                      >
                        <div class="cases-item">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="cases-item-img">
                                <img
                                        src="../assets/image/home-11.png"
                                        class="img-fluid"
                                        alt="img"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="cases-item-txt">
                                <div class="cases-item-img">
                                  <img
                                          src="../assets/image/home-11-2.png"
                                          class="img-fluid"
                                          alt="img"
                                  />
                                </div>
                                <h5>{{ $t("home.xizang") }}</h5>
                                <i></i>

                                <p>
                                  {{ $t("home.xizang_txt") }}
                                </p>
                                <router-link
                                        :to="{ path: '/cases/detail', query: { id: 4 } }"
                                        tag="a"
                                        class="moreBtn"
                                >
                                  more
                                  <img
                                          src="../assets/image/home-right.png"
                                          class="img-fluid"
                                          alt="more"
                                  />
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                    <el-carousel-item style="height:500px;margin-top: 70px">
                      <div class="swiper-slide"
                      >
                        <div class="cases-item">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="cases-item-img">
                                <img
                                        src="../assets/image/home-12.png"
                                        class="img-fluid"
                                        alt="img"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="cases-item-txt">
                                <div class="cases-item-img">
                                  <img
                                          src="../assets/image/home-12-2.png"
                                          class="img-fluid"
                                          alt="img"
                                  />
                                </div>
                                <h5>{{ $t("home.lake") }}</h5>
                                <i></i>

                                <p>
                                  {{ $t("home.lake_txt") }}
                                </p>
                                <router-link
                                        :to="{ path: '/cases/detail', query: { id: 5 } }"
                                        tag="a"
                                        class="moreBtn"
                                >
                                  more
                                  <img
                                          src="../assets/image/home-right.png"
                                          class="img-fluid"
                                          alt="more"
                                  />
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>




          </el-carousel>
          <!-- 手机版轮播图 -->
          <div class="swiper-container swiper2 d-xs-block d-md-none">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper2-slide">
                <div class="swiper2-img">
                  <img
                    src="../assets/image/home-cases-1.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="swiper2-con">
                  <h3>{{ $t("home.chongqing") }}</h3>
                  <span>{{ $t("home.luyu") }}</span>
                  <p>
                    {{ $t("home.chongqing_txt3") }}
                  </p>
                  <div class="more">
                    <router-link
                      :to="{ path: '/cases/detail', query: { id: 1 } }"
                      tag="a"
                      class="moreBtn"
                    >
                      more
                      <img
                        src="../assets/image/home-right.png"
                        class="img-fluid"
                        alt="more"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="swiper-slide swiper2-slide">
                <div class="swiper2-img">
                  <img
                    src="../assets/image/home-cases-2.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="swiper2-con">
                  <h3>{{ $t("home.sichuan") }}</h3>
                  <span> {{ $t("home.Newheight") }}</span>
                  <p>{{ $t("home.sichuan_txt") }}</p>
                  <div class="more">
                    <router-link
                      :to="{ path: '/cases/detail', query: { id: 2 } }"
                      tag="a"
                      class="moreBtn"
                    >
                      more
                      <img
                        src="../assets/image/home-right.png"
                        class="img-fluid"
                        alt="more"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="swiper-slide swiper2-slide">
                <div class="swiper2-img">
                  <img
                    src="../assets/image/home-cases-3.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="swiper2-con">
                  <h3>{{ $t("home.xinjian") }}</h3>
                  <span>{{ $t("home.newlength") }}</span>
                  <p>
                    {{ $t("home.xinjian_txt") }}
                  </p>
                  <div class="more">
                    <router-link
                      :to="{ path: '/cases/detail', query: { id: 3 } }"
                      tag="a"
                      class="moreBtn"
                    >
                      more
                      <img
                        src="../assets/image/home-right.png"
                        class="img-fluid"
                        alt="more"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="swiper-slide swiper2-slide">
                <div class="swiper2-img">
                  <img
                    src="../assets/image/home-cases-4.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="swiper2-con">
                  <h3>{{ $t("home.xizang") }}</h3>
                  <span>{{ $t("home.high_altitude") }}</span>
                  <p>
                    {{ $t("home.xizang_txt") }}
                  </p>
                  <div class="more">
                    <router-link
                      :to="{ path: '/cases/detail', query: { id: 4 } }"
                      tag="a"
                      class="moreBtn"
                    >
                      more
                      <img
                        src="../assets/image/home-right.png"
                        class="img-fluid"
                        alt="more"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="swiper-slide swiper2-slide">
                <div class="swiper2-img">
                  <img
                    src="../assets/image/home-cases-5.png"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="swiper2-con">
                  <h3>{{ $t("home.lake") }}</h3>
                  <span>{{ $t("home.fastrise") }}</span>
                  <p>
                    {{ $t("home.lake_txt") }}
                  </p>
                  <div class="more">
                    <router-link
                      :to="{ path: '/cases/detail', query: { id: 5 } }"
                      tag="a"
                      class="moreBtn"
                    >
                      more
                      <img
                        src="../assets/image/home-right.png"
                        class="img-fluid"
                        alt="more"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination swp2"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { log } from "util";
import $ from 'jquery'
export default {
  inject:['reload'],
  components: {},
  props: {},
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      cases: [
        {
          id: 1,
          index: 0,
          title: this.$t("home.luyu"),
          h5: this.$t("home.chongqing"),

          url: require("@/assets/image/home-7.png"),
          isActive: true,
          isShow: true,
        },
        {
          id: 2,
          index: 1,
          title: this.$t("home.Newheight"),
          h5: "四川-去学水电站",

          url: require("@/assets/image/home-9.png"),
          isActive: false,
          isShow: false,
        },
        {
          id: 3,
          index: 2,
          title: this.$t("home.newlength"),
          h5: "新疆-库什塔依水电站",

          url: require("@/assets/image/home-10.png"),
          isActive: false,
          isShow: false,
        },
        {
          id: 4,
          index: 3,
          title: this.$t("home.high_altitude"),
          h5: "西藏-恰央水库",

          url: require("@/assets/image/home-11.png"),
          isActive: false,
          isShow: false,
        },
        {
          id: 5,
          index: 4,
          title: this.$t("home.fastrise"),
          h5: "新疆-喀英德布拉克",

          url: require("@/assets/image/home-12.png"),
          isActive: false,
          isShow: false,
        },
      ],
      shebei: [
        {
          id: 1,
          index: 1,
          h5: this.$t("home.cedingyi"),
          p: this.$t("home.cedingyi_txt"),
          url: require("@/assets/image/home-shebei-2.png"),
          isShow: true,
        },
        {
          id: 2,
          index: 2,
          h5: this.$t("home.shiyanyi"),
          p: this.$t("home.shiyanyi_txt"),
          url: require("@/assets/image/home-shebei-3.png"),
          isShow: false,
        },
        {
          id: 3,
          index: 3,
          h5: this.$t("home.liqing"),
          p: this.$t("home.liqing_txt"),
          url: require("@/assets/image/home-shebei-4.png"),
          isShow: false,
        },
      ],
      timer:'',
      showIndex: 1,
      bgBanner: [
        {
          id: 1,
          url: require("../assets/image/home-banner.png"),
        },
        {
          id: 2,
          url: require("../assets/image/home-banner2.png"),
        },
        {
          id: 3,
          url: require("../assets/image/home-banner3.jpeg"),
        },
      ],
      currentIndex:0,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // 设置分页器
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable :true
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // 设置自动轮播
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        // 设置轮播可循环
        loop : true
      },
      bgBanner2: [
        {
          id: 1,
          url: require("../assets/image/mobile-banner-sm.png"),
        },
        {
          id: 2,
          url: require("../assets/image/mobile-home-banner-2.png"),
        },
        {
          id: 3,
          url: require("../assets/image/mobile-home-banner-3.png"),
        },
      ],
    };
  },
  methods: {
    changeCases(index) {
      this. cases.forEach((v) =>
                v.index === index ? (v.isActive= true) : (v.isActive = false)
      );
      // this.cases.forEach((v) =>
      //   v.index === index ? (v.isShow = true) : (v.isShow = false)
      // );
    },
    // nextBtn(num) {
    //   this.showIndex += num
    //   if (this.showIndex == 4) {
    //     this.showIndex = 1
    //   }
    //   this.shebei.forEach((v) => {
    //     v.index === this.showIndex ? (v.isShow = true) : (v.isShow = false)
    //   })

    //   console.log(this.showIndex)
    // },
    // preBtn(num) {
    //   this.showIndex += num
    //   if (this.showIndex == 0) {
    //     this.showIndex = 3
    //   } else if (this.showIndex == -1) {
    //     this.showIndex = 2
    //   }

    //   this.shebei.forEach((v) => {
    //     v.index === this.showIndex ? (v.isShow = true) : (v.isShow = false)
    //   })
    //   console.log(this.showIndex)
    // },
    initSwiper() {
      var swiper = new Swiper(".swiper1", {
        pagination: ".swp1",
        loop: true, //图片无限转动
        autoplay: 1000,
        grabCursor: true, //手掌

        onSlideChangeStart: (swiper) => {
          this.changeCases(swiper.realIndex);
        }
      });
      // clearInterval(this.timer)
    },
    on_over(){
      // this.$refs.mySwiper.$swiper.autoplay.stop()
      let swiper = new Swiper(".swiper1", {
        autoplay:false
      });
    },
    on_enter() {
      console.log("444")

      let swiper = new Swiper(".swiper1", {
        autoplay:false
      });
    },
    changeCarouse(info){
      // this.tabTile(parseInt(info))
      // isActive
      this.changeCases(parseInt(info))
      console.log(info,"info")
    },
    on_leave() {
      // this.swiper.autoplaying = true;
      console.log("33")
      let swiper = new Swiper(".swiper1", {
        autoplay:true
      });
      // swiper.autoplay.start();
      },
    buttonLeave(){
      this.swiper.autoplaying = true;
    },
    tabTile(item){
      item.isActive=true
      this.swiper.slideTo(item.index+1, 0, true)
      this.cases.forEach((v) =>
              v.index === item.index ? (v.isActive= true) : (v.isActive = false)
      );
      // this.reload()
      var swiper = new Swiper(".swiper1", {
        pagination: ".swp1",
        loop: false, //图片无限转动
        autoplay: 2000,
        grabCursor: true, //手掌
        onSlideChangeStart: (swiper) => {
          this.changeCases(swiper.realIndex);
        },
      });

    },

    clickTba(index){
      this.currentIndex = index;
    },
    shebeiSwiper() {
      var swiper2 = new Swiper(".swiper2", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true, //图片无限转动
        pagination: ".swp2",
        autoplay: 2000,
      });
    },
    // bannerSwiper() {
    //   var swiper3 = new Swiper(".swiper3", {
    //     pagination: {
    //       el: ".swp3",
    //       clickable: true,
    //     },

    //     loop: true, //图片无限转动
    //     //autoplay: 2000,
    //   });
    // },
  },
  created() {},
  mounted() {
    this.initSwiper();
    this.shebeiSwiper();
    // const item={isActive:false,index:0}
    // this.setTimer()

    // this.bannerSwiper();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    // myBotSwiper() {
    //   return this.$refs.myBotSwiper.swiper
    // }

  },
};
</script>
<style lang="less">
  .pcSwiper{

  .el-carousel__indicators{
    /*background: red;*/
    bottom: 670px;
    /*background: transparent!important;*/
    height: 50px;
    width: 100%;
    /*left: -10px;*/
    /*position: fixed;*/
    margin-left: 10px;
    z-index: 10000000!important;
    /*z-index: 100000000;*/
    /*float: left;*/
    /*background: yellow;*/
    /*position: relative;*/

  }
  .el-carousel__indicator .el-carousel__indicator--horizontal .is-active{
    outline: none!important;
    border: none!important;
  }
  .el-carousel__button{
    width: 210px!important;
    border-radius: 10% !important;
    height: 90px!important;
    background: transparent!important;
    outline: none!important;
    border: none!important;
    /*position: absolute;*/
    /*display: inline-block;*/

  }
  }

</style>
<style lang="less" scoped>
.home {
  overflow: hidden;
}

.img-fluid{
  /*height: 96!important;*/
  /*border: 1px solid red;*/
/*  height: 631px!important;*/
  height: 100%;
}
.banner {
  // background: url('../assets/image/home-banner.png') no-repeat;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  height: 500px;
  position: relative;
  top: 140px;
  margin-bottom: 140px;
  width: 100%
}
.carousel-box {
  position: relative;

}
.banner_title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-family: PingFang SC;
  color: #ffffff;
  text-align: center;
  font-weight: 300;
  letter-spacing: 10px;
  z-index: 100;
}
.swp3 /deep/.swiper-pagination-bullet {
  width: 60px;
  height: 10px;
  background: #ffffff;
  border-radius: 5px;
  opacity: 1;
}

.swp3 /deep/.swiper-pagination-bullet-active {
  width: 60px;
  height: 10px;
  background: #054ea4;
  border-radius: 5px;
}

//公司简介
.home-item {
  .title {
    background: url("../assets/image/home-brief.png") no-repeat;
    background-position: left;
    background-size: contain;
    font-size: 30px;
    font-weight: 800;
    font-style: italic;
    color: #054ea4;
    margin: 13px 0 100px 31px;
  }

  .huize-img {
    width: 160%;
    z-index: 100;
    position: relative;
  }
  .brief_txt {
    // height: 460px;
    background: #f5f5f5;
    padding: 30px 25px;
    position: relative;
    &::before {
      display: block;
      content: "";
      background: url("../assets/image/biaodian1.png") no-repeat;
      width: 42px;
      height: 26px;
    }
    &::after {
      position: absolute;
      display: block;
      content: "";
      background: url("../assets/image/biaodian2.png") no-repeat;
      width: 42px;
      height: 26px;
      right: 54px;
      bottom: 23px;
    }
    p {
      line-height: 26px;
      color: #333333;
      font-size: 14px;
      text-indent: 2em;
      margin-bottom: 24px;
    }
    .brief_txt_p1 {
      margin-top: 28px;
    }
  }
}
.brief {
  margin-top: 110px;
}
//四个模块
.company_brief {
  display: flex;
  flex-wrap: wrap;
  margin-top: 100px;
  justify-content: space-between;
  border: 1px solid #f5f5f5;
  margin-bottom: 0;
  .brief_item {
    display: flex;

    width: 25%;
    flex-direction: column;
    align-items: center;
    padding: 39px 47px;
    flex-shrink: 0;
    &:hover {
      box-shadow: 0px 0px 20px 0px rgba(5, 78, 164, 0.1);
    }
    .brief_img {
      width: 77px;
      height: 76px;
      text-align: center;
    }
    h5 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin: 18px 0 10px 0;
    }
    p {
      text-align: center;
      font-size: 14px;
      color: #333333;
      margin-bottom: 0;
      width: 100%;
    }
  }
}

//工程案例
.cases {
  position: relative;
  margin-bottom: 300px;
  height: 500px;
  background: #f5f5f5;
  padding-top: 50px;
  margin-top: 100px;
  z-index: 1;

  .title-box {
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 50px;

  }
  .title {
    background-image: url("../assets/image/home-cases.png");
    margin: 0;

  }
  .more {
    text-align: right;
    .moreBtn {
      text-transform: uppercase;
      color: #333333;
      font-size: 16px;
    }
  }
}
.cases-title {
  display: flex;
  margin-bottom: 130px;
  position: relative;

  li {
    width: 20%;
    background: #ffffff;
    background-size: 100%;
    background-position: center;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    margin: 0 5px;
    a {
      color: #343434;
      text-align: center;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .clickActive {
    background: #054ea4;
    box-shadow: 0px 0px 10px 0px rgba(1, 63, 137, 0.2);

    a {
      color: #ffffff;
      text-align: center;
    }
  }
}
.cases_box {
  /*background: red;*/

  .cases-item {
    margin-top: 40px;
    .cases-item-txt {
      .moreBtn {
        color: rgba(51, 51, 51, 1);
        text-transform: uppercase;
      }
      h5 {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        margin-top: 43px;
      }
      i {
        display: block;
        width: 47px;
        height: 2px;
        background: #064ea4;
        margin: 10px 0 0 0;
      }
      p {
        margin: 28px 0 24px 0;
        font-size: 14px;
        color: #000000;
        line-height: 26px;
        text-indent: 2em;
        padding: 0 10px;
      }
    }
  }
}
.showSJ {
  display: none;
}

//专业设备
.shebei {
  background: #0d1b37;
  padding-bottom: 95px;
  .container {
    position: relative;
  }
  .title-box {
    align-items: center;
    justify-content: space-between;
    margin: 120px 0 15px 0;
  }
  .title {
    background-image: url("../assets/image/home-shebei-1.png");
    color: #ffffff;
    margin: 0;
  }
  .more {
    text-align: right;
    .moreBtn {
      color: #ffffff;
    }
  }
}
.shebei-content {
  height: 580px;

  .shebei-txt-box {
    height: 580px;
  }
  .shebei-txt {
    background: #ffffff;
    position: relative;
    height: 100%;
    display: table;

    .txt {
      display: table-cell;
      vertical-align: middle;
      padding: 0 30px;
      h5 {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
        width: 100%;
      }
    }

    .toggleBtn {
      position: absolute;
      bottom: 30px;
      right: 0;
      transform: translateX(50%);
      height: 50px;
      background: #262626;
      opacity: 0.8;
      display: flex;
      z-index: 10;
      .preBtn,
      .nextBtn {
        padding: 11px 20px;
        cursor: pointer;
      }
    }
  }
  .shebei-img {
    img {
      height: 100%;
    }
  }
}
.swiper2 {
  width: 100%;
}

.swiper2-con {
  overflow: hidden;
  padding: 10px 25px;
  h3 {
    font-size: 14px;
    color: #333333;
    margin: 0 0 16px 0;
  }
  span {
    display: block;
    width: 75px;
    height: 20px;
    background: #054ea4;
    border-radius: 5px;
    color: #ffffff;
    text-align: center;
    line-height: 20px;
  }
  p {
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    margin: 13px 0;
  }
  .more {
    text-align: center;
  }
}
.swiper2-img {
  background-position: center;
  img {
    height: 100%;
    width: 100%;
  }
}

//专业技术
.skill {
  .container {
    position: relative;
  }
  .title-box {
    align-items: center;
    justify-content: space-between;
    margin: 100px 0 48px 0;
  }
  .title {
    background-image: url("../assets/image/home-skill-1.png");
    margin-top: 50px;
  }
  .more {
    text-align: right;
  }
}
.skill-item {
  .skill-item-title {
    font-size: 26px;
    font-weight: bold;
    color: #064ea4;
    margin-bottom: 35px;
  }
  .skill-item-con {
    h5 {
      font-size: 20px;
      font-weight: bold;
      color: #343434;
      margin-top: 17px;
    }
    p {
      font-size: 18px;
      font-weight: 400;
      color: #000000;
    }
  }
}
.skill-top {
  margin-top: 75px;
}
.skill-top2 {
  margin-top: -80px;
}
.skill-top3 {
  margin-top: 50px;
}

// 公司动态
.news {
  .title {
    background-image: url("../assets/image/home-news-1.png");
    text-align: center;
    margin: 0 auto;
    background-position: center;
    margin-top: 100px;
  }
}
.news-box {
  margin-top: 50px;
  margin-bottom: 80px;
  .new-item {
    display: flex;
    margin-bottom: 20px;
    .news-date {
      flex: 1;
      h3 {
        font-size: 28px;
        font-weight: 800;
        font-style: italic;
        color: #666666;
        margin-bottom: 0;
      }
      h5 {
        font-size: 16px;
        font-weight: 800;
        font-style: italic;
        color: #666666;
      }
    }
    .news-con {
      flex: 5;
      border-left: 3px solid #f5f5f5;
      padding-left: 20px;
      h5 {
        font-size: 18px;
        font-weight: bold;
        color: #666666;
        line-height: 30px;
      }
      p {
        font-size: 18px;
        font-weight: 400;
        color: #666666;
      }
      a {
        img {
          border: none;
        }
      }
    }
  }
}
.pcSwiper{
  /*height: 500px;*/
  /*background: red;*/
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*height: 500px!important;*/
  /*height: 900px;*/
  /*border: 1px solid red;*/
  /*margin-top: -100px;*/
}
//轮播图样式
.swiper-container {
  width: 100%;
  height: 100%;
  /*background-size: 10%;*/
}
.swiper-slide {
  // margin-right: 1px;
  border: 1px solid transparent;
}
.swp1 {
  display: none;
}
/deep/.el-carousel__container {
  height: 640px;
}
/deep/.el-carousel__button {
  width: 60px;
  height: 10px;
  background: #ffffff;
  border-radius: 5px;
  opacity: 1;
}
/deep/.el-carousel__indicator.is-active button {
  background: #054ea4;
}

@media (max-width: 1200px) and (min-width: 1024px) {
  .home-item .brief_txt {

  }
  .app{
    display: none;
  }
  .brief .title {
    margin: 5px 0 50px 20px;
    width: 350px;
    font-size: 22px;
  }

  .home-item .brief_txt[data-v-8dc7cce2]::before,
  .home-item .brief_txt[data-v-8dc7cce2]::after {
    width: 25px;
    height: 20px;
    background-size: 100%;
  }
  .home-item .brief_txt[data-v-8dc7cce2]::after {
    right: 25px;
    bottom: 20px;
  }
  .home-item .brief_txt p[data-v-8dc7cce2] {
    margin-bottom: 10px;
  }
}
@media(max-width: 991px)  {

}
//ipad  端样式
@media (max-width: 1024px) and (min-width: 768px) {
  .banner {
    top: 75px;
    margin-bottom: 75px;
    height: 350px;
  }
  .app-swiper{
    display: none;
  }
  /deep/.el-carousel__container {
    height: 350px;
  }
  .banner_title {
    font-size: 40px;
  }

  .brief {
    margin-top: 43px;
  }
  .brief .title {
    margin: 5px 0 20px 20px;
  }
  .home-item .title {
    font-size: 18px;
  }
  .home-item .brief_txt {
    padding: 25px 14px;

    &::before {
      width: 21px;
      height: 13px;
      background-size: 100%;
    }
    &::after {
      width: 21px;
      height: 13px;
      background-size: 100%;
      bottom: 30px;
    }
  }

  .company_brief .brief_item {
    padding: 20px 18px;
    margin-right: 15px;
    flex: 1;
  }
  .company_brief .brief_item:not(:last-child) {
    &::before {
      display: none;
    }
  }
  .cases_box .cases-item {
    height: 340px;
  }
  .cases .cases-item .cases-item-txt {
    p {
      font-size: 15px;
      margin: 0;
    }
  }

  .shebei .title {
    background-position: left;
    text-align: left;
  }
  .showPC {
    display: none;
  }
  .showSJ {
    display: block;
  }

  .more .moreBtn {
    font-size: 14px !important;
  }

  .company_brief .brief_item {
    .brief_img {
      width: 39px;
      height: 39px;
      img {
        height: 100%;
      }
    }
  }
  .company_brief {
    margin-top: 50px;
  }
  .company_brief .brief_item {
    h5,
    p {
      font-size: 14px;
    }
  }
  .cases {
    margin-top: 100px;
    padding-top: 25px;
    height: 305px;
    .title {
      margin: 0 !important;
    }
    .title-box {
      margin-bottom: 22px;
    }
  }
  .cases_box .cases-item {
    margin-top: 18px;
  }
  .home-item .brief_txt p[data-v-8dc7cce2] {
    margin-bottom: 10px;
  }
  .home-item .brief_txt .brief_txt_p1[data-v-8dc7cce2] {
    margin-top: 10px;
  }
  .home-item .brief_txt[data-v-8dc7cce2]::before,
  .home-item .brief_txt[data-v-8dc7cce2]::after {
    width: 25px;
    height: 20px;
    background-size: 100%;
  }
  .home-item .brief_txt[data-v-8dc7cce2]::after {
    right: 25px;
    bottom: 20px;
  }
  .home-item .brief_txt p[data-v-8dc7cce2] {
    margin-bottom: 10px;
  }
}
@media (max-width: 768px) and (min-width: 320px) {
  .cases_box .cases-item .cases-item-txt h5 {
    margin-top: 15px;
    font-size: 18px;
  }
  .cases {
    margin-bottom: 211px;
    margin-top: 50px;
  }
}
//手机端  端样式
@media (max-width: 767px) and (min-width: 320px) {
  .swiper3 {
    display: none;
  }
  .app-swiper{
    display: block;
  }
  .pcSwiper{
    display: none;
  }
  .banner-mobile {
    width: 100%;
    height: 230px;
    /*background-size: 100% 100%;*/
  }
  /deep/.el-carousel__container {
    height: 230px;
    margin-top: 50px;
  }
  /deep/.el-carousel__button {
    width: 20px;
    height: 10px;
    background: #ffffff;
    border-radius: 5px;
    opacity: 1;
  }
  .brief {
    margin-top: 0;
  }
  .banner_title {
    font-size: 24px;
    padding: 0 10px;
  }
  .swp1 {
    display: block;
  }
  .cases {
    height: 350px;
    padding: 0;
    background: #ffffff;

    z-index: 1;
    .cases-title {
      display: none;
    }
    .title-box {
      margin-bottom: 25px;
    }
  }
  .showPC {
    display: none;
  }
  .showSJ {
    display: block;
    padding: 15px;
  }
  .cases .cases-item .cases-item-txt {
    padding: 10px;
  }

  .shebei .container {
    height: 445px;
    padding-top: 40px;
  }
  .brief .title {
    margin: 50px 0 25px 0;
  }
  .brief .title,
  .cases .title {
    font-size: 18px !important;
    // margin: 25px 0 !important;
    width: 244px;
  }
  .skill {
    margin-top: 100px;
  }
  .more {
    font-size: 12px;
  }
  .shebei .more {
    top: 30px;
  }
  .skill-top2 {
    margin-top: 30px;
  }
  .company_brief .brief_item:not(:last-child) {
    &::before {
      display: none;
    }
  }
  .company_brief {
    margin-top: 50px;
    .brief_item {
      padding: 13px;
      margin-bottom: 10px;
      width: 49%;

      background: #f5f5f5;
      .brief_img {
        width: 39px;
        height: 39px;
        img {
          height: 100%;
        }
      }
      h5,
      p {
        font-size: 14px;
      }
    }
  }
  .more .moreBtn {
    font-size: 12px !important;
    img {
      width: 8px;
      height: 7px;
    }
  }
  .swiper-container {
    overflow: visible;
    /*display: none;*/
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    position: relative;
    bottom: -35px;
  }
  .swiper2-slide {
    box-shadow: 0px 0px 10px 0px rgba(5, 78, 164, 0.2);
  }
  .brief-mobile {
    .txt-box {
      p {
        line-height: 23px;
        text-indent: 2em;
      }
    }
  }
  .carousel {
    height: 230px;
  }
}

</style>
